import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/filter.svg'
import _imports_1 from '@/assets/editIcon.svg'
import _imports_2 from '@/assets/deleteIcon.svg'


const _hoisted_1 = { class: "maincontainer py-8 px-4 w-full" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Configurations")
], -1)
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-3 ml-2.5"
}, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "flex mt-4"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, "Configuration name", -1)
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, "Created", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", { class: "cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center pl-5" }, [
    /*#__PURE__*/_createElementVNode("div", null, "Actions")
  ])
], -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "searchRow" }
const _hoisted_15 = { class: "searchRow" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "cursor-pointer" }
const _hoisted_19 = { class: "child-action-col" }
const _hoisted_20 = { class: "flex flex-row align-center" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "h-5 w-5 mt-2"
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "h-5 w-5 mt-2"
}, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "Popup w-full"
}
const _hoisted_28 = { class: "fixed inset-0 z-50 justify-center items-center flex" }
const _hoisted_29 = { class: "relative w-4/6 my-6 mx-auto max-w-4xl" }
const _hoisted_30 = { class: "popup border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "p-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "formcontainer flex mr-2" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Create Configuration")
  ])
], -1)
const _hoisted_32 = { class: "statuscontainer p-2" }
const _hoisted_33 = { class: "formcontainer flex flex-col" }
const _hoisted_34 = { class: "row flex flex-row w-full" }
const _hoisted_35 = { class: "col-md-6 w-6/12 p-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Configuration", -1)
const _hoisted_37 = { class: "col-md-6 w-6/12 p-2 mt-6 flex flex-row-reverse" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_39 = { class: "p-2" }
const _hoisted_40 = { class: "controlMetaData flex mt-2" }
const _hoisted_41 = { class: "w-1/2" }
const _hoisted_42 = { class: "controllabel font-normal text-sm mb-1" }
const _hoisted_43 = {
  key: 0,
  type: "text",
  class: "inputboxstyling"
}
const _hoisted_44 = {
  key: 0,
  class: "w-1/2"
}
const _hoisted_45 = {
  key: 0,
  type: "radio"
}
const _hoisted_46 = {
  key: 1,
  type: "checkbox"
}
const _hoisted_47 = { class: "ml-2 mb-2" }
const _hoisted_48 = {
  key: 1,
  class: "w-1/2"
}
const _hoisted_49 = { class: "inputboxstyling" }
const _hoisted_50 = { class: "flex justify-end mb-4 items-end mr-4" }
const _hoisted_51 = {
  key: 0,
  class: "opacity-25 fixed inset-0 z-40 bg-black"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, {
            to: { name: 'createConfiguration' },
            class: "btnprimary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Add new")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("button", {
          class: "filterButton cursor-pointer ml-3 flex",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
        }, [
          _createTextVNode(" Filters "),
          _hoisted_5
        ])
      ])
    ]),
    (_ctx.configData.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _createElementVNode("table", null, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", {
                      class: "cursor-pointer",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sort('name')))
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("div", {
                          class: _normalizeClass(["sort cursor-pointer", _ctx.className == 'name' ? _ctx.classSort : 'opacity-50'])
                        }, null, 2)
                      ])
                    ]),
                    _createElementVNode("th", {
                      class: "cursor-pointer",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sort('createdAt')))
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("div", {
                          class: _normalizeClass(["sort cursor-pointer", _ctx.className == 'createdAt' ? _ctx.classSort : 'opacity-50'])
                        }, null, 2)
                      ])
                    ]),
                    _hoisted_12
                  ]),
                  (_ctx.showFilters)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                        _createElementVNode("td", _hoisted_14, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "inputboxstyling",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterDummy.name) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.filterDummy.name]
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_15, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "inputboxstyling",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterDummy.createdAt) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.filterDummy.createdAt]
                          ])
                        ]),
                        _hoisted_16
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.configData.length > 0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (config, configindex) => {
                        return (_openBlock(), _createElementBlock("tr", { key: configindex }, [
                          _createElementVNode("td", _hoisted_18, _toDisplayString(config.name), 1),
                          _createElementVNode("td", null, _toDisplayString(config.createdAt), 1),
                          _createElementVNode("td", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", {
                                class: "px-1 py-0 cursor-pointer",
                                onClick: ($event: any) => (_ctx.editConfiguration(config._id))
                              }, _hoisted_23, 8, _hoisted_21),
                              _createElementVNode("div", {
                                class: "px-1 py-0 cursor-pointer",
                                onClick: ($event: any) => (_ctx.deleteConfiguration(config))
                              }, _hoisted_26, 8, _hoisted_24)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showPreview)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", null, [
                  _hoisted_31,
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _hoisted_36,
                            _createElementVNode("p", null, _toDisplayString(_ctx.configDatas.name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("button", {
                              class: "btnprimary",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.editConfig(_ctx.configDatas._id)))
                            }, "editConfig")
                          ])
                        ])
                      ]),
                      _hoisted_38
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configDatas.controls, (control, controlIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "text-black no-underline mt-0.5 min-h-30 cursor-pointer",
                      key: controlIndex
                    }, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("label", _hoisted_42, _toDisplayString(control.label), 1),
                              (control.controlType == 'TextBox' || control.controlType == 'TextArea')
                                ? (_openBlock(), _createElementBlock("input", _hoisted_43))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          (control.controlType == 'Radio' || control.controlType == 'CheckBox')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configDatas.controls[controlIndex].options, (option) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "min-h-30",
                                    key: option
                                  }, [
                                    (control.controlType == 'Radio')
                                      ? (_openBlock(), _createElementBlock("input", _hoisted_45))
                                      : _createCommentVNode("", true),
                                    (control.controlType == 'CheckBox')
                                      ? (_openBlock(), _createElementBlock("input", _hoisted_46))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("label", _hoisted_47, _toDisplayString(option.option), 1)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (control.controlType == 'Dropdown')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                _createElementVNode("select", _hoisted_49, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configDatas.controls[controlIndex].options, (option) => {
                                    return (_openBlock(), _createElementBlock("option", { key: option }, _toDisplayString(option.option), 1))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("button", {
                      class: "btnprimary",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.close()))
                    }, "Close")
                  ])
                ])
              ])
            ])
          ]),
          (_ctx.showPreview)
            ? (_openBlock(), _createElementBlock("div", _hoisted_51))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}